/**
 * A body part an athlete measures over time, besides body weight (that one is a weigh-in).
 * Height is here too: the profile keeps the latest, this keeps every change.
 */
export enum BodyMeasurementKind {
  WAIST = "waist",
  HIPS = "hips",
  CHEST = "chest",
  ARM = "arm",
  THIGH = "thigh",
  CALF = "calf",
  NECK = "neck",
  BODY_FAT = "body_fat",
  HEIGHT = "height",
}

/** Each kind's unit and the values a real reading can take; anything outside is a typo. */
export const BODY_MEASUREMENT_RULES: Record<BodyMeasurementKind, { unit: "cm" | "%"; min: number; max: number }> = {
  [BodyMeasurementKind.WAIST]: { unit: "cm", min: 40, max: 200 },
  [BodyMeasurementKind.HIPS]: { unit: "cm", min: 50, max: 200 },
  [BodyMeasurementKind.CHEST]: { unit: "cm", min: 50, max: 200 },
  [BodyMeasurementKind.ARM]: { unit: "cm", min: 15, max: 70 },
  [BodyMeasurementKind.THIGH]: { unit: "cm", min: 25, max: 100 },
  [BodyMeasurementKind.CALF]: { unit: "cm", min: 20, max: 70 },
  [BodyMeasurementKind.NECK]: { unit: "cm", min: 20, max: 70 },
  [BodyMeasurementKind.BODY_FAT]: { unit: "%", min: 2, max: 70 },
  [BodyMeasurementKind.HEIGHT]: { unit: "cm", min: 100, max: 250 },
};

/** Which way a progress photo was taken, so like is compared with like. */
export enum ProgressPhotoPose {
  FRONT = "front",
  SIDE = "side",
  BACK = "back",
}
